import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from '@app/core';
import { Testexam } from '@app/models/testexam';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'trial-exam-result-dialog',
  templateUrl: 'trial-exam-result-dialog.component.html',
  styleUrls: ['./trial-exam-result-dialog.component.scss'],
})
export class TrialExamResultDialogComponent
  extends BaseComponent
  implements OnInit
{
  public result!: Testexam;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public dataSource!: MatTableDataSource<any>;

  public displayedColumns: string[] = [
    'category',
    'count_correct',
    'count_wrong',
    'count_needed_correct',
    'percentage_correct',
    'status',
  ];

  constructor(
    public dialogRef: MatDialogRef<TrialExamResultDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    if (this.data.result) {
      this.result = this.data.result;
      this.dataSource = new MatTableDataSource(this.result.categories);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(data?: any): void {
    this.dialogRef.close(data);
  }
}
